export default __webpack_public_path__ + "static/media/roadmap-banner-right.46158217.svg";